module.exports = __webpack_public_path__ + "static/media/no-data.f497ff1f.png";